import { RouterReducerState, routerReducer } from '@ngrx/router-store';

export interface State {
  router: RouterReducerState;
}

export const reducers = {
  router: routerReducer
};
